import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    darkmode: false,
    user: {
      authenticated: false,
      data: null
    }
  },

  getters: {
    user(state){
      return state.user
    },
    darkmode(state){
      return state.darkmode
    }
  },

  mutations: {
    changeTheme(state) {
      state.darkmode = !state.darkmode;
    },
    setAuthenticated(state, value) {
      state.user.authenticated = value;
    },
    setUser(state, data) {
      state.user.data = data
    }
  },

  actions: {
    fetchUser({ commit }, user) {
      commit("setAuthenticated", user !== null);
      if (user) {
        user.getIdToken().then(response => {
          commit("setUser", {
            displayName: user.displayName,
            email: user.email,
            emailVerified: user.emailVerified,
            photoURL: user.photoURL,
            isAnon: user.isAnon,
            uid: user.uid,
            providerData: user.providerData,
            token: response
          });
        })
      } else {
        commit("setUser", null);
      }
    }
  },

  plugins: [createPersistedState()],
})